import { formatChileanDateFull } from './dateUtils';

const ADMIN_TEMPLATE_NAME = 'Administrador';

// Only the owner may promote someone to Administrador, so a non-owner's role
// selector, on invite and on a role change, does not offer it.
export function visibleTemplatesFor(templates, actingIsOwner) {
  if (actingIsOwner) return templates;
  return templates.filter((t) => t.name !== ADMIN_TEMPLATE_NAME);
}

// Normalizes a /memberships/members row into the shape the team UI consumes.
// Shared by Configuración (full team table) and CausaDetalle (encargado
// lookup, which only reads .id/.nombre off the result).
export function mapOrgMembers(list) {
  return list.map((raw, idx) => {
    const m = raw.member ?? raw;
    const u = m.user ?? raw.user ?? m;
    const isPending = (m.status ?? raw.status) === 'INVITED';
    const fullName =
      `${u.firstName ?? m.firstName ?? ''} ${u.lastName ?? m.lastName ?? ''}`.trim();
    const correo = u.email || m.email || raw.invitedEmail || '—';
    // An invite carries no name, so a row can have none. The email always
    // exists, so it stands in for the name before a dash does.
    return {
      id: m.entityId ?? m.id ?? raw.id ?? idx,
      userId: m.userId ?? raw.userId,
      nombre: fullName || (correo !== '—' ? correo : '—'),
      correo,
      ingreso: formatChileanDateFull(m.createdAt || raw.createdAt) ?? '—',
      templateId: m.template?.id,
      rol: m.isOwner ? 'Propietario' : m.template?.name,
      rolVariant: m.isOwner ? 'owner' : '',
      esAdmin: !m.isOwner && !!m.permissions?.includes('org:manage-members'),
      estado: isPending ? 'pending' : 'active',
      estadoLabel: isPending ? 'Invitación pendiente' : 'Activo',
      accion: isPending ? 'Reenviar' : 'Ver',
    };
  });
}

// Where a non-owner lands after leaving an organization: back in the app when
// refreshUser() found another membership, and logged out otherwise, also when
// the refresh produced no result.
export function postLeaveDestination(refreshResult) {
  if (refreshResult && refreshResult.membershipCount > 0) {
    return { kind: 'reenter' };
  }
  return { kind: 'logout' };
}
